// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import driverReducer from '../features/driver/driverSlice';
import profileReducer from '../features/profile/profileSlice';
import servicesReducer from '../features/services/servicesSlice';
import availabilityReducer from '../features/availability/availabilitySlice';
import serviceRadiusReducer from '../features/serviceRadius/serviceRadiusSlice';
import notificationReducer from '../features/notifications/notificationSlice';
import flashSalesReducer from '../features/flashSales/flashSalesSlice'; 
import serviceLocationsReducer from "../features/serviceLocations/serviceLocationSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    driver: driverReducer,
    profile: profileReducer,
    services: servicesReducer,
    availability: availabilityReducer,
    serviceRadius: serviceRadiusReducer,
    notifications: notificationReducer,
    flashSales: flashSalesReducer, 
    serviceLocations: serviceLocationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;